// extracted by mini-css-extract-plugin
export default {"container":"AutoSuggest__container___2Ax01"};